export default __webpack_public_path__ + "static/media/addfile.5e414b1a.png";